import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (process.env.NODE_ENV === 'development') {
  console.log('[Supabase] Init:', { url: supabaseUrl, hasKey: !!supabaseKey });
}

export const supabase = createClient(supabaseUrl, supabaseKey);